import type { ReactNode } from "react";
import type { ViewMode } from "./view-mode";

export interface EntityListLayoutProps {
  viewMode: ViewMode;
  table: ReactNode;
  cards?: ReactNode;
  list?: ReactNode;
  fallback?: ReactNode;
}

/**
 * Thin mode-branch helper for unified entity lists.
 */
export function EntityListLayout({
  viewMode,
  table,
  cards,
  list,
  fallback,
}: EntityListLayoutProps) {
  switch (viewMode) {
    case "table":
      return <>{table}</>;
    case "cards":
      return <>{cards ?? fallback ?? table}</>;
    case "list":
    default:
      return <>{list ?? fallback ?? table}</>;
  }
}
